import client from "./axiosConfig";

export const getUsers = () => {
  const config = {
    url: "/users/",
    method: "GET",
  };
  const response = client(config);
  return response;
};

export const updateUser = (data) => {
  const config = {
    url: "/users/",
    method: "PATCH",
    data,
  };
  const response = client(config);
  return response;
};

export const getAllCompanyUsers = (params) =>
{
  const config = {
    url: "/users/company-users/",
    method: "GET",
    params
  };
  const response = client(config);
  return response;
}

export const updateComapnyUsers = (id,data) =>
{
  const config = {
    url: `/users/company-users/${id}/`,
    method: "PATCH",
    data
  }
  const response = client(config);
  return response;
}
